import styles from "./progressCircle.module.css"

const startColor = "var(--app-start-color)";
const midColor = "var(--app-mid-color)";
const endColor = "var(--app-end-color)";

export const ProgressCircle = ({ progress, size = 100, strokeWidth = 8, backcolor, onClick, children }) => {
    const color = (progress < .34) ? startColor : (progress < .67) ? midColor : endColor;
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;

    return (
        <div onClick={onClick} className={styles.progressbar_circle_container}>
            <svg className={styles.progressbar_circle} width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx={size / 2} cy={size / 2} r={radius}
                    fill="none"
                    stroke={backcolor ? backcolor : "var(--app-status-bar-bg-color)"}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                />
                <circle
                    cx={size / 2} cy={size / 2} r={radius}
                    style={{ transition: "stroke-dashoffset .3s ease-out" }}
                    fill="none"
                    stroke={color}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={circumference * Math.min(1, Math.max(0, (1 - progress)))}
                    transform={`rotate(-90 ${size / 2} ${size / 2})`}
                />
            </svg>

            <div className={styles.progressbar_circle_info}>
                {children}
            </div>
        </div>
    )
}